import React, { useState, useEffect, Fragment, useCallback } from 'react';
import {
    Card, CardBody, Button, TabContent, TabPane, NavItem, CardHeader, Nav, Row,
    UncontrolledDropdown,
    DropdownMenu,
    Input,
    CustomInput
} from 'reactstrap';
import { useDropzone } from 'react-dropzone'
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';
import { gAPI_UserUploads, API_TODO_JSON } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import SelectedJson from './components/SelectedJson';
import { NotificationManager } from '../../../../../components/common/react-notifications';

function Index({ propertyId, exportAllData, togglegallery, LoadData, hideUserUploads, searchText, uploadLink }) {

    if (hideUserUploads === undefined) {
        hideUserUploads = false;
    }
    if (searchText === undefined) {
        searchText = '';
    }

    const [activeTab, setActiveTab] = useState('embed');
    const [loading, setLoading] = useState(true);
    const [bmbloading, setbmbLoading] = useState(true);
    const [photos, setphotos] = useState([]);
    const [bmbphotos, setbmbphotos] = useState([]);
    const [chosenImage, setchosenImage] = useState('');

    const toggleAppMenu = tab => {
        setActiveTab(tab)
    };
    const [selectAll, setSelectAll] = useState(false);
    const imageRenderer = useCallback(
        ({ index, left, top, key, photo }) => (
            <SelectedJson
                selected={selectAll ? true : false}
                key={key}
                margin={"2px"}
                index={index}
                photo={photo}
                left={left}
                top={top}
                ParentImage={ParentImage}
                chosenImage={chosenImage}
                ParentDeleteImage={ParentDeleteImage}
                ParentEditImage={ParentEditImage}
            />
        )
    );

    const fileObj = [];
    const handleSubmit = () => {
        if (isAgree) {
            const data = new FormData();
            files.forEach(file => {

                data.append('files', file.img);
                data.append('tags', file.tags)
                data.append('captions', file.caption)
            });
            data.append('propertyId', propertyId)
            data.append('groupId', getGroupID());
            data.append('creator', 'dashboard');


            // setApiState("processing")
            AxiosAPI({
                method: 'post',
                url: `${API_TODO_JSON}`,
                data: data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(
                res => {
                    LoadData();
                    togglegallery();
                    // setApiState('success')
                    // toggleModal();
                    // parentLoadData();
                },
                error => {
                    //  setApiState('fail')
                    console.log('eee.data', error.data);
                }
            );
        }
    };
    const [files, setFiles] = useState([]);
    const [isAgree, setAgree] = useState(true);
    const [errorModal, showErrorModal] = useState(false);
    const [ApiState, setApiState] = useState('default');
    const readJsonFile = (file) =>
        new Promise((resolve, reject) => {
            const fileReader = new FileReader()

            fileReader.onload = event => {
                if (event.target) {
                    resolve(JSON.parse(event.target.result))
                }
            }

            fileReader.onerror = error => reject(error)
            fileReader.readAsText(file)
        });
    const { getRootProps, getInputProps } = useDropzone({
        //accept: 'image/*',
        // accept: 'image/*,font/*',                              
        onDrop: acceptedFiles => {
            acceptedFiles.map(file => {
                if (file.name.includes('json')) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        if (isJsonString(e.target.result)==true) {                            
                            fileObj.push(
                                {
                                    img: Object.assign(file, {
                                        preview: URL.createObjectURL(file)
                                    }),
                                    tags: [],
                                    caption: ''
                                });
                            setFiles([...files, ...fileObj]);
                        } else {
                            NotificationManager.error(
                                '',
                                'File content is not valid',
                                3000,
                                null,
                                null,
                                'error'
                            );
                        }
                    }
                    reader.readAsText(file);                   
                }
            });
            
        }
    });

    function isJsonString(str) {
        try {
          var content =  JSON.parse(str);          
          if(content[0].length > 0 && content[0].filter((c)=>
          c.title === undefined || c.title ==="" || c.category === undefined || c.category ==="" &&
          c.setup === undefined || c.setup ==="" || c.startDate === undefined ||
          c.endDate === undefined || c.status === undefined
          ).length ==0){
            return true;
          }
          else{
            return false;
          }
        } catch (e) {
            return false;
        }
        return true;
    }
    const ParentImage = (id) => {
        setchosenImage(id)
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        bmbphotos[objIndex].selected = true;
        setbmbphotos(bmbphotos)
    }
    const exportData = () => {
        const json = JSON.stringify([[
            {
                "title": "",
                "subTitle": "",
                "icon": "",
                "text": "",
                "links": [
                    {
                        "url": "",
                        "text": ""
                    },
                    {
                        "url": "",
                        "text": ""
                    },
                    {
                        "url": "",
                        "text": ""
                    }
                ],
                "category": "Setup",
                "status": "Active",
                "country": "",
                "startDate": "",
                "endDate": ""
            }
        ]]);
        const blob = new Blob([json], { type: "application/json" });
        const href = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.download = "sampleTo-Do.json";

        link.click();
    };
    const ParentDeleteImage = (id) => {
        const values = [...bmbphotos];
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        values.splice(objIndex, 1);
        setbmbphotos(values)
    }

    const ParentEditImage = (id, tags) => {
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        bmbphotos[objIndex].tags = true;
        setbmbphotos(bmbphotos)
    }

    const ParentUserDeleteImage = (id) => {
        const values = [...photos];
        let objIndex = photos.findIndex((obj => obj.id == id));
        values.splice(objIndex, 1);
        setphotos(values);
    }


    return (
        <Fragment>
            <TabContent
                activeTab={activeTab}
                className=""
            >
                <TabPane tabId="embed" className="chat-app-tab-pane">
                    <Card className="mb-0">
                        <CardBody>
                            <Row className="mt-0">
                                <Colxx xxs="12">
                                    <Fragment>
                                        <Row className="mb-0 text-right justify-content-end mr-2">
                                            <a onClick={exportAllData}><span style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }} >Export Current To-Do</span></a>
                                            <a className='ml-2' onClick={exportData}><span style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }} >Download Sample</span></a>
                                        </Row>
                                        <Row className="mb-4">
                                            <section className="container">
                                                <div {...getRootProps({ className: 'dropzone' })}>
                                                    <input {...getInputProps()} />
                                                    <div class="dz-default dz-message">
                                                        <span>Drop file here to upload, or click to select file

                                                        </span>
                                                        <p className="font-weight-medium mb-0 ">
                                                            <i className="demo-icon simple-icon-cursor-move"></i>
                                                        </p>
                                                    </div>

                                                </div>
                                                <div className="filepicker dropzone-gallery dz-clickable dz-started" style={{ minHeight: '160px', border: '0px' }}
                                                >
                                                    {files.map((file, index) => (
                                                        <div className="dz-preview dz-file-preview mb-3" key={index}>
                                                            <div className="row">
                                                                <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                                                                    <div>
                                                                        <span data-dz-name>{file.img.name}</span>{" "}
                                                                    </div>
                                                                    <div className="text-primary text-extra-small" data-dz-size>{file.img.size}</div>
                                                                </div>

                                                            </div>

                                                            {/* <a href="#/" className="remove" data-dz-remove
                                                                onClick={() => handleRemoveFields(index)}
                                                            >
                                                                {" "}
                                                                <i className="glyph-icon simple-icon-trash" />{" "}
                                                            </a> */}
                                                        </div>

                                                    ))}
                                                </div>
                                            </section>
                                        </Row>
                                        {/* <div className='d-flex text-center ml-0 font-weight-bold mt-1 mb-2' style={{ justifyContent: 'center' }}>
                                            <CustomInput
                                                type="checkbox"
                                                id="agree"
                                                value={isAgree}
                                                checked={isAgree}
                                                onChange={(e) => {
                                                    setAgree(!isAgree);
                                                }}
                                            >
                                                <span className='mt-1' style={{ verticalAlign: 'sub' }}>I have copyright or permissions to use this json file</span>

                                            </CustomInput>
                                        </div> */}
                                        <div className='mt-2 d-flex' style={{ justifyContent: 'center' }}>
                                            <Button color="primary" onClick={handleSubmit}
                                                className={`btn-multiple-state text-white ${classnames(
                                                    {
                                                        "show-spinner": ApiState === "processing",
                                                        "show-success": ApiState === "success",
                                                        "show-fail": ApiState === "fail"
                                                    }
                                                )}`}
                                            >
                                                <span className="spinner d-inline-block">
                                                    <span className="bounce1" />
                                                    <span className="bounce2" />
                                                    <span className="bounce3" />
                                                </span>
                                                <span className="icon success">
                                                    <i className="simple-icon-check" />
                                                </span>
                                                <span className="icon fail">
                                                    <i className="simple-icon-exclamation" />
                                                </span>
                                                <span className="label">Upload</span>
                                            </Button>

                                        </div>
                                    </Fragment>
                                </Colxx>
                            </Row>
                        </CardBody>
                    </Card>
                </TabPane>
            </TabContent>
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, email } = settings;
    return {
        propertyId, email
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
